import React, { useEffect, useState } from "react"
import { Rating } from "@mui/material"
import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore"
import { firestore } from "../config/db" // Adjust the import path to your Firebase config

const RatingComponent = ({ uid, setFeedbackList, onRatingDocChanged }) => {
  const [defaultRating, setDefaultRating] = useState(0)
  const [bronislawaSkupChecked, setBronislawaSkupChecked] = useState(false)
  const [error, setError] = useState("")

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const userDocRef = doc(firestore, `submissions/${uid}`)
        const feedbackCollectionRef = collection(userDocRef, "feedback")
        const querySnapshot = await getDocs(feedbackCollectionRef)

        const feedbackData = querySnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }))
        setFeedbackList(feedbackData)
      } catch (err) {
        console.error("Error fetching feedback: ", err)
        setError("Nie udało się pobrać komentarzy.")
      }
    }

    const fetchMyRating = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"))
        const adminId = user.uid

        const userDocRef = doc(firestore, `submissions/${uid}`)
        const ratingCollectionRef = collection(userDocRef, "rating")
        const ratingDocRef = doc(ratingCollectionRef, adminId)
        const docSnapshot = await getDoc(ratingDocRef)

        if (docSnapshot.exists()) {
          const ratingDocData = docSnapshot.data()
          setDefaultRating(
            typeof ratingDocData?.rating === "number" &&
              Number.isFinite(ratingDocData.rating)
              ? ratingDocData.rating
              : 0,
          )
          setBronislawaSkupChecked(
            Boolean(ratingDocData?.bronislawaSkupScholarship),
          )
        } else {
          setDefaultRating(0)
          setBronislawaSkupChecked(false)
        }
      } catch (err) {
        console.error("Error fetching rating: ", err)
        setError("Nie udało się pobrać ocen.")
      }
    }

    fetchFeedback()
    fetchMyRating()
  }, [uid, setFeedbackList])

  const persistRatingDoc = async ({ rating, bronislawaSkupScholarship }) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"))
      const adminId = user.uid
      const adminEmail = user.email

      const userDocRef = doc(firestore, `submissions/${uid}`)
      const ratingCollectionRef = collection(userDocRef, "rating")
      const ratingDocRef = doc(ratingCollectionRef, adminId)

      await setDoc(
        ratingDocRef,
        {
          rating: typeof rating === "number" ? rating : defaultRating,
          bronislawaSkupScholarship:
            typeof bronislawaSkupScholarship === "boolean"
              ? bronislawaSkupScholarship
              : bronislawaSkupChecked,
          adminId,
          adminEmail,
          timestamp: new Date(),
        },
        { merge: true },
      )

      onRatingDocChanged?.()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div>
      <h5 style={{ margin: 0, marginBottom: 8, color: "black" }}>Ocena</h5>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 24,
          flexWrap: "wrap",
        }}
      >
        <Rating
          name="size-large"
          value={defaultRating}
          size="large"
          max={10}
          onChange={(event, newValue) => {
            const next = newValue || 0
            setDefaultRating(next)
            persistRatingDoc({ rating: next })
          }}
          className="custom-rating"
        />
        <label
          style={{ display: "flex", alignItems: "center", gap: 8, margin: 0 }}
        >
          <input
            type="checkbox"
            style={{
              width: 22,
              height: 22,
              accentColor: "#f7a81b",
              cursor: "pointer",
            }}
            checked={bronislawaSkupChecked}
            onChange={(e) => {
              const checked = e.target.checked
              setBronislawaSkupChecked(checked)
              persistRatingDoc({ bronislawaSkupScholarship: checked })
            }}
          />
          <span style={{ fontWeight: 600, color: "black" }}>
            Stypendium im. Bronisławy Skup
          </span>
        </label>
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  )
}

export default RatingComponent
